import React, {
  useState, useContext, useEffect
} from "react";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";
import TableContainer from "@material-ui/core/TableContainer";
import FileSaver from "file-saver";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Loading from "../core/Loading";
import CircularProgress from "@material-ui/core/CircularProgress";
import ModalMui from "../core/ModalMui";
import DTEStatusMui from "../core/DTEStatusMui";
import AlertPermanent from "../core/AlertPermanent";
import AuthContext from "../../context/authentication/authContext";
import TableContext from "../../context/table/tableContext";
import AlertContext from "../../context/alert/alertContext";

import DoneAllIcon from "../../assets/icon/done_all_black_24dp.svg";
import DoneIcon from "../../assets/icon/done_black_24dp.svg";
import ApprovedWithWarningIcon from "../../assets/icon/rule_black_24dp.svg";
import RejectedIcon from "../../assets/icon/highlight_off_black_24dp.svg";

import "./TransactionTable.css";
import { EditOutlined } from "@material-ui/icons";
import PaymentDetailsMui from "./PaymentDetailsMui";
import AlertMui from "../core/AlertMui";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import BillContext from "../../context/bill/BillContext";

const styles = (theme) => ({
  root: {
    display: "flex",
    marginTop: theme.spacing(3),
    height: "100%",
    overflow: 'auto',
  },
  table: {
    minWidth: 340,
  },
  tableCell: {
    padding: "16px",
    color: "#12b1ee",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 70,
  },
  documentNumber: {
    cursor: "pointer",
  },
  actionIcon: {
    cursor: 'pointer',
    paddingLeft: '15px',
    fontSize: '2.5rem',
    color: '#101070'
  },
  referenceSelection: {
  }
});

const TransactionTable = (props) => {
  const authContext = useContext(AuthContext);
  const { user, closeSession, hasToChange } = authContext;
  const tableContext = useContext(TableContext);
  const billContext = useContext(BillContext);
  const [modalShow, setModalShow] = useState(false);
  const showModal = () => setModalShow(true);
  const closeModal = () => setModalShow(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [currrectBill, setCurrentBill] = useState()
  const [billToRefer, setBillToRefer] = React.useState()
  const [referenceSelection, setReferenceSelection] = React.useState()
  const [loadingReference,setLoadingReference] = React.useState(false)

  const alertContext = useContext(AlertContext);
  const {
    loading,
    changePage,
    currentPage,
    error,
    errorMessage,
    getExportFileXml,
    getDteStatus,
    getTransactionDetail,
    voidTransaction,
  } = tableContext;
  const{
    // setBillAllParams,
    getBill,
    customerId,
    shopId,
    billData
  } = billContext
  const {
    classes,
    columns,
    data,
    totalPages,
    maxPerPage,
    setMaxPerPage,
  } = props;

  const { alert, showAlert } = alertContext;

  const handlePagination = (e, page) => {
    e.preventDefault();
    changePage(page);
  };

  const handleChangeRowsPerPage = (e) => {
    setMaxPerPage(parseInt(e.target.value, 10));
  };

  const showStatusModal = async (number, documentType, dteStatusId, status) => {
    setModalTitle("Estado del documento");
    if (status === 'SentToSii') {
      setModalContent(
        <DTEStatusMui closeModal={closeModal} dteStatus={status} number={number} documentType={documentType} ></DTEStatusMui>
      );

    }
    else {
      const response = await getDteStatus(number, documentType, dteStatusId);
      //console.log(response)
      //console.log(response.response.data)
      if (response.response.data.data.responseCode == 0) {
        setModalContent(
          <DTEStatusMui closeModal={closeModal} dteStatus={status} number={number} message={response.response.data.data.message} description={response.response.data.data.description} documentType={documentType} ></DTEStatusMui>
        );
      } else {
        setModalContent(
          <DTEStatusMui closeModal={closeModal} dteStatus={'Unknown'} description={response.response.data.data.responseMessage} number={number} documentType={documentType} ></DTEStatusMui>
        );
      }
    }

    showModal();


  }

  const downloadFile = async (number, documentType) => {
    try {
      const response = await getExportFileXml(number, documentType);
      if (!response.status) {
        showAlert("Ha ocurrido un error con la descarga", "error");
      } else {
        showAlert("Archivo descargado", "success");
        return FileSaver.saveAs(response.xmlData, `Folio${number}-${documentType}.xml`);
      }
      /* showAlert("Archivo descargado", "success"); */
    } catch (error) {
      showAlert("Ha ocurrido un error con la descarga", "error");
    }
  };

  const showPaymentDetails = async (element) => {
    setModalTitle("Detalles de la transacción");
    setModalContent(
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 150 }}>
        <CircularProgress />
      </div>
    );
    showModal();
    const result = await getTransactionDetail(element.internalReference);
    if (result?.status) {
      const data = result.response.data.data;
      setModalContent(
        <PaymentDetailsMui
          closeModal={closeModal}
          data={data}
          onVoid={() => voidTransaction(element.internalReference)}
        />
      );
    } else {
      setModalContent(
        <Box style={{ padding: "8px 0 0" }}>
          <AlertMui message="Error al obtener el detalle" type="error" />
          <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
            <Button onClick={closeModal} color="primary" variant="outlined" size="small">
              Cerrar
            </Button>
          </Box>
        </Box>
      );
    }
  };

  const referBill = (event) => {
    const customers = JSON.parse(localStorage.getItem('customers'))
    getBill(customers[0].id, customers[0].shops[0].id, event.currentTarget.attributes['data'].value)
    const bill = data.find(item => item.id === Number(event.currentTarget.attributes.data.value))
    setBillToRefer(bill)
  }

  React.useEffect(() => {
    setLoadingReference(false)
    if (billData && billData.data && billData.data.availableDocumentsToReference == null) {
      alert('Este documento no se puede referenciar')
      return
    }

    if (billData && billData.data && billData.data.availableDocumentsToReference && billData.data.availableDocumentsToReference.length) {
      const nrs = []
      billData.data.availableDocumentsToReference.forEach(x => {
        if (x.availableReasonToRefer !== null) {
          nrs.push({
            value: x.typesToRefer,
            label: 'Generar ' + documentTypeToName(x.typesToRefer),
            typesToRefer: x.typesToRefer
          })
        }
      })
      if (billToRefer) {
        const dt = {}
        dt.documentUniqueNumber = billToRefer.number
        dt.documentType = billToRefer.documentType === "Afecta" ? 39 : 41
        dt.documentDate = billToRefer.date.substring(0, 10)
        dt.availableDocumentsToReference = billData.data.availableDocumentsToReference
        dt.Details = billData.data.details
        dt.ReceiverId = billData.data.receiverId
        dt.documentId = billData.data.id
        props.showReferencesOptions(nrs, dt)
      }
    }
  }, [billData])

  function documentTypeToName(type){
    switch(type){
        case 33:
        case 34:
        case 46:
            return 'Factura'
        case 56: return 'Nota de Débito'
        case 61: return 'Nota de Crédito'
        case 52: return 'Guía de depacho'
    }
  }

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <AlertPermanent category="error" message={errorMessage} />;
  }

  if (data.length === 0 && !error) {
    return (
      <AlertPermanent
        category="info"
        message="No se han encontrado transaciones..."
      />
    );
  }

  return (
    <>
      <ModalMui
        modalShow={modalShow}
        showModal={showModal}
        closeModal={closeModal}
        modalTitle={modalTitle}
      >
        {modalContent}
      </ModalMui>
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                (column.name !== "Estado" || (user != null ? user.includes("tas_") : false)) &&
                <TableCell
                  key={index}
                  align={column.name === "Monto" ? "right" : "center"}
                  className={classes.tableCell}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((element, index) => {
              return (
                <TableRow key={'TableRow' + index}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.TableCell}
                    align="center"
                  >
                    {moment(element.date).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell align="center">
                    {moment(element.date).format("HH:mm:ss")}
                  </TableCell>
                  <TableCell align="center">{element.documentType}</TableCell>
                  <TableCell align="center"
                    className={classes.documentNumber}
                    onClick={() => {
                      downloadFile(element.number, element.documentType);
                    }}>{element.number}</TableCell>
                  <TableCell align="right">
                    ${Number(element.amount).toLocaleString("da-DK")}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={element.canShowDetails ? () => showPaymentDetails(element) : undefined}
                    style={element.canShowDetails ? { cursor: "pointer", color: "#12b1ee" } : undefined}
                  >
                    {element.paymentMethod}
                  </TableCell>
                  {(user != null ? user.includes("tas_") : false) &&
                    <TableCell align="center" onClick={
                      () => {
                        showStatusModal(element.number, element.documentType, element.dteStatusId, element.status);
                      }
                    }> {
                        element.status === "SentToSii" &&
                        <img
                          src={DoneIcon}
                          title="Enviado al SII"
                          alt="Enviado al SII"
                        />
                      }
                      {
                        element.status === "RejectedBySii" &&
                        <img
                          src={RejectedIcon}
                          title="Rechazado por SII"
                          alt="Rechazado por SII"
                        />
                      }
                      {
                        element.status === "ApprovedBySii" &&
                        <img
                          src={DoneAllIcon}
                          title="Aprobado por SII"
                          alt="Aprobado por SII"
                        />
                      }
                      {
                        element.status === "ApprovedWithWarningsBySii" &&
                        <img
                          src={ApprovedWithWarningIcon}
                          title="Aprobado con reparos por SII"
                          alt="Aprobado con reparos por SII"
                        />
                      }

                    </TableCell>
                  }
                  <TableCell >
                    {
                      localStorage.getItem("hasIntegrationsRole") === "true" &&
                      <EditOutlined className={classes.actionIcon} data={element.id} onClick={referBill} />
                    }
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Registros</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={maxPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          page={currentPage}
          count={totalPages}
          onChange={handlePagination}
          style={{ marginTop: "10px", justifyContent: "center" }}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(TransactionTable);
